<template>
  <div >
    <TopBar />
	<!--start-download-->
	<div class="download" id="download">
		<div class="container">
			<div class="download-main">
				<div class="download-top">
					<div class="download-block">
						<div class="title">微运康</div>
						<div class="logo">
							<img src="@/assets/img/down-hp.png"/>
						</div>
						<div class="download-android" @click="download">Android APP下载</div>
					</div>
					<div class="clearfix"></div>
				</div>
			</div>
		</div>
	</div>
	<!--end-download-->
	<div class="about" id="about">
		<div class="container">
			<div class="about-main">
				<h3>产品</h3>
					<div class="about-top">
						<div class="col-md-4 about-left">
							<img src="../assets/img/abt-1.png" alt=""/>
							<h4>数据追踪</h4>
							<h5>提供区块链数据追踪服务</h5>
							<ul>
								<li><a href="#"><span class="fb"> </span></a></li>
								<li><a href="#"><span class="sap"> </span></a></li>
							</ul>
						</div>
						<div class="col-md-4 about-left">
							<img src="../assets/img/abt-2.png" alt=""/>
							<h4>区块链溯源</h4>
							<h5>提供一体化的区块链溯源服务</h5>
							<ul>
								<li><a href="#"><span class="fb"> </span></a></li>
								<li><a href="#"><span class="sap"> </span></a></li>
							</ul>
						</div>
						<div class="col-md-4 about-left">
							<img src="../assets/img/abt-3.png" alt=""/>
							<h4>APP开发</h4>
							<h5>混合模式基于uniapp开发小程序/App</h5>
							<ul>
								<li><a href="#"><span class="fb"> </span></a></li>
								<li><a href="#"><span class="sap"> </span></a></li>
							</ul>
						</div>
						<div class="clearfix"></div>
					</div>
			</div>
		</div>
	</div>
	<!--end-about-->
	<!--start-what-->
	<div class="what" id="work">
		<div class="container">
			<div class="what-main">
				<h3>优势</h3>
				<div class="what-top">
					<div class="col-md-6 what-top-left">
						<h4><span>优势一</span> 专注于区块链底层服务五年</h4>
						<h5>有深厚的技术积累沉淀</h5>
						<p>熟悉各种公链的加密签名以及验证逻辑，能够快速的搭建/二次开发市面上主流公链，能够帮助企业快速的实施区块链落地应用，我们只专注技术领域</p>
					</div>
					<div class="col-md-6 what-top-right">
						<img src="../assets/img/service-1.png" alt=""/>
					</div>
					<div class="clearfix"></div>
				</div>
				<div class="what-middle">
					<div class="col-md-6 what-middle-left">
						<img src="../assets/img/service-2.png" alt=""/>
					</div>
					<div class="col-md-6 what-middle-right">
						<h4><span>优势二</span> 有成熟的开源产品</h4>
						<h5>产品推动技术前进</h5>
						<p>现有的开源产品多如牛毛，但是精品却寥若晨星，而且搭建起来异常复杂</p>
					</div>
					<div class="clearfix"></div>
				</div>
				<div class="what-top">
					<div class="col-md-6 what-top-left">
						<h4><span>优势三</span> 提供大量优质的免费接口</h4>
						<h5>时刻关注技术前沿</h5>
						<p>接口都是实验性的，以驱动区块链技术应用为己任</p>
					</div>
					<div class="col-md-6 what-top-right">
						<img src="../assets/img/service-3.png" alt=""/>
					</div>
					<div class="clearfix"></div>
				</div>
			</div>
		</div>
	</div>
	<!--end-what-->
	<!--start-project-->
	<div class="project" id="services">
		<div class="col-md-3 project-left">
			<img src="../assets/img/project-1.jpg" alt=""/>
			<span>
				<img src="../assets/img/p-icon1.png" alt=""/>
			</span>
			<div class="project-bottom">
				<h4>数据追踪</h4>
				<label> </label>
				<p>提供主流币种的数据追踪服务</p>
				<div class="p-btn">
					<a href="#">查看</a>
				</div>
			</div>
		</div>
		<div class="col-md-3 project-left">
			<img src="../assets/img/project-2.jpg" alt=""/>
			<span>
				<img src="../assets/img/p-icon2.png" alt=""/>
			</span>
			<div class="project-bottom">
				<h4>合约解读审计</h4>
				<label> </label>
				<p>提供智能合约的解读审计服务</p>
				<div class="p-btn">
					<a href="#">查看</a>
				</div>
			</div>
		</div>
		<div class="col-md-3 project-left">
			<img src="../assets/img/project-3.jpg" alt=""/>
			<span>
				<img src="../assets/img/p-icon3.png" alt=""/>
			</span>
			<div class="project-bottom">
				<h4>图片分析</h4>
				<label> </label>
				<p>大量图片下分析出助记词私钥图片</p>
				<div class="p-btn">
					<a href="#">查看</a>
				</div>
			</div>
		</div>
		<div class="col-md-3 project-left">
			<img src="../assets/img/project-4.jpg" alt=""/>
			<span>
				<img src="../assets/img/p-icon4.png" alt=""/>
			</span>
			<div class="project-bottom">
				<h4>数据预警</h4>
				<label> </label>
				<p>提供数据预警接口服务</p>
				<div class="p-btn">
					<a href="#">查看</a>
				</div>
			</div>
		</div>
		<div class="clearfix"></div>
	</div>
	<!--end-project-->
	<!--start-price-->
	<!-- <div class="price" id="pricing">
		<div class="container">
			<div class="price-main">
				<h3>价格</h3>
				<div class="price-top">
					<div class="col-md-4 price-left">
						<div class="price-left-one" id="hexagon">
							<div class="price-left-two">
								<h5>SAVING PACK</h5>
								<p><sup>$</sup><span>15.99</span>/MO</p>
								<a href="#"> </a>
							</div>
							<ul>
								<li><a href="#">First Service</a></li>
								<li><a href="#">Second Service</a></li>
								<li><a href="#">Third Service</a></li>
								<li><a href="#">Fourth Service</a></li>
							</ul>
						</div>
					</div>
					<div class="col-md-4 price-left">
						<div class="price-left-middle" id="hexagon2">
							<div class="price-left-top">
								<h5>STANDARD PACK</h5>
								<p><sup>$</sup><span>25.99</span>/MO</p>
								<a href="#"> </a>
							</div>
							<ul>
								<li><a href="#">First Service</a></li>
								<li><a href="#">Second Service</a></li>
								<li><a href="#">Third Service</a></li>
								<li><a href="#">Fourth Service</a></li>
								<li class="fth"><a href="#">Fifth Service</a></li>
								<li class="fth"><a href="#">6th Service</a></li>
							</ul>
						</div>
					</div>
					<div class="col-md-4 price-left">
						<div class="price-left-middle" id="hexagon1">
							<div class="price-left-two">
								<h5>ULTRA PACK</h5>
								<p><sup>$</sup><span>35.99</span>/MO</p>
								<a href="#"> </a>
							</div>
							<ul>
								<li><a href="#">First Service</a></li>
								<li><a href="#">Second Service</a></li>
								<li><a href="#">Third Service</a></li>
								<li><a href="#">Fourth Service</a></li>
								<li class="fth"><a href="#">Fifth Service</a></li>
								<li class="fth"><a href="#">6th+7th Service</a></li>
							</ul>
						</div>
					</div>
					<div class="clearfix"></div>
				</div>
			</div>
		</div>
	</div> -->
	<!--end-price-->
	<!--start-quality-->
	<div class="quality">
		<div class="container">
			<div class="quality-main">
				<h3>保障</h3>
				<p>SEE OUR PROCESS</p>
				<div class="quality-top">
					<div class="quality-top-one">
						<span> </span>
						<div class="quality-bottom quality-bottom-rsh">
							<label class="rsh"> </label>
							<p>需求分析</p>
						</div>
					</div>
					<div class="quality-top-one">
						<span class="one"> </span>
						<div class="quality-bottom quality-bottom-dsg">
							<label class="dsg"> </label>
							<p>产品原型</p>
						</div>
					</div>
					<div class="quality-top-one">
						<span> </span>
						<div class="quality-bottom quality-bottom-pro">
							<label class="pro"> </label>
							<p>设计定型</p>
						</div>
					</div>
					<div class="quality-top-one">
						<span class="one"> </span>
						<div class="quality-bottom quality-bottom-imp">
							<label class="imp"> </label>
							<p>代码开发</p>
						</div>
					</div>
					<div class="quality-top-one">
						<span> </span>
						<div class="quality-bottom quality-bottom-luh">
							<label class="luh"> </label>
							<p>测试验收</p>
						</div>
					</div>
					<div class="clearfix"></div>
				</div>
			</div>
		</div>
	</div>
	<!--end-quality-->
	<!--start-clients-->
	<div class="clients">
		<div class="container">
			<div class="clients-mian">
				<h3>案例</h3>
				<div  id="top" class="callbacks_container">
			      	<ul class="rslides" id="slider4">
			        <li>
						<div class="clients-top">
							<div class="clients-left">
								<!-- <img src="../assets/img/clients-1.png" alt=""/> -->
								<a class="index-anli" href="http://www.rmaqw.com/"><p>人民安全网</p>
								<p>http://www.rmaqw.com/</p></a>


								<!-- <img src="../assets/img/clients-1.png" alt=""/> -->
							</div>
							<div class="clients-left">
								<a class="index-anli" href="http://www.bjzhkd.com"><p>中航科电</p>
								<p>http://www.bjzhkd.com</p></a>

								<!-- <img src="../assets/img/clients-2.png" alt=""/>
								<img src="../assets/img/clients-2.png" alt=""/> -->
							</div>
							<div class="clients-left">
								<a class="index-anli" href="http://www.cnsunbird.com/"><p>亚光科技集团股份有限公司</p>
								<p>http://www.cnsunbird.com/</p></a>

								<!-- <img src="../assets/img/clients-3.png" alt=""/>
								<img src="../assets/img/clients-3.png" alt=""/> -->
							</div>
							<div class="clearfix"></div>
						</div>
					</li>
					<li>
						<div class="clients-top">
							<div class="clients-left">
								<!-- <img src="../assets/img/clients-2.png" alt=""/>
								<img src="../assets/img/clients-2.png" alt=""/> -->
								<a class="index-anli" href="http://51yins.com"><p>51印刷网</p>
								<p>51yins.com</p></a>

							</div>
							<div class="clients-left">
								<!-- <img src="../assets/img/clients-3.png" alt=""/>
								<img src="../assets/img/clients-3.png" alt=""/> -->
								<a class="index-anli" href="http://www.voc.com.cn/"><p>华声在线</p>
								<p>http://www.voc.com.cn/</p></a>

							</div>

							<div class="clearfix"></div>
						</div>
					</li>
					<!-- <li>
						<div class="clients-top">
							<div class="clients-left">
								<img src="../assets/img/clients-3.png" alt=""/>
								<img src="../assets/img/clients-3.png" alt=""/>
							</div>
							<div class="clients-left">
								<img src="../assets/img/clients-1.png" alt=""/>
								<img src="../assets/img/clients-1.png" alt=""/>
							</div>
							<div class="clients-left">
								<img src="../assets/img/clients-2.png" alt=""/>
								<img src="../assets/img/clients-2.png" alt=""/>
							</div>
							<div class="clearfix"></div>
						</div>
					</li> -->
			      </ul>
			    </div>
			    <div class="clearfix"> </div>
			</div>
			<div class="clients-bottom">
				<p>AND THEY SAYS</p>
				<div class="clients-bottom-top">
					<div class="clients-btm">
						<div  id="top" class="callbacks_container">
			      		<ul class="rslides" id="slider5">
			        	<li>
							<div class="clients-btm-one">
								<img src="../assets/img/clients-4.png" alt=""/>
								<h4>ANNA DOE</h4>
								<P>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</P>
							</div>
						</li>
						<li>
							<div class="clients-btm-one">
								<img src="../assets/img/clients-5.png" alt=""/>
								<h4>INGA NORTH</h4>
								<P>Magna aliquadolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</P>
							</div>
						</li>
						<li>
							<div class="clients-btm-one">
								<img src="../assets/img/clients-6.png" alt=""/>
								<h4>JACOB PARKER</h4>
								<P>Ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</P>
							</div>
						</li>
			      		</ul>
			    		</div>
			    	<div class="clearfix"> </div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="blog" id="blogs">
		<div class="container">
			<div class="blog-main">
				<h3>Our Blogs</h3>
				<div class="blog-top">
					<div class="col-md-4 blog-left">
						<img src="../assets/img/blog-1.png" alt="">
						<span> </span>
						<h4>WHAT TO WRITE?</h4>
					</div>
					<div class="col-md-4 blog-left">
						<img src="../assets/img/blog-2.png" alt="">
						<span> </span>
						<h4>WHAT TO WRITE?</h4>
					</div>
					<div class="col-md-4 blog-left">
						<img src="../assets/img/blog-3.png" alt="">
						<span> </span>
						<h4>WHAT TO WRITE?</h4>
					</div>
					<div class="clearfix"></div>
				</div>
				<div class="b-btn">
					<a href="#">Read More!</a>
				</div>
			</div>
		</div>
	</div>
	<!--end-blog-->
	<!--start-contact-->
	<div class="touch" id="contact">
		<div class="container">
			<div class="touch-main">
				<h3>联系</h3>
				<div class="touch-top">
					<div class="col-md-6 touch-left">
						<p>留言</p>
						<form @submit="send" action="url" enctype="multipart/form-data" target="frameName">
							<input type="text" class="active" placeholder="姓名" v-model="talka.name" required="">
							<input type="text" placeholder="邮箱" required="" v-model="talka.email">
							<input type="text" placeholder="标题" required="" v-model="talka.title">
							<textarea placeholder="内容" required="" v-model="talka.text"></textarea>
							<div class="sub-button">
								<input type="submit" value="发送">
							</div>
						</form>
						<iframe src="" frameborder="0" name="frameName"></iframe>
					</div>
					<div class="col-md-6 touch-right">
						<div class="touch-right-bottom">
							<div class="touch-right-top">
								<span class="add"> </span>
								<h4>西安市灞桥区长乐东路2999号<label>京都国际2楼201</label></h4>
							</div>
							<div class="touch-right-top">
								<span class="mail"> </span>
								<p><a href="emainto:xpbb@qq.com4tt">xpbb@qq.com</a></p>
							</div>
							<div class="touch-right-top">
								<span class="num"> </span>
								<p>{{talka.name}}</p>
							</div>
						</div>
					</div>
					<div class="clearfix"></div>
				</div>
			</div>
		</div>
	</div>
	<Footer />
  </div>
</template>
<script>

import TopBar from '../components/topbar.vue'
import Footer from "../components/footer.vue"
import '../assets/js/jquery-1.11.0.min.js'
import   "../assets/js/responsiveslides.min.js"
export default {
  components: {
    TopBar,Footer
  },
  data(){
	  return{

		  talka:{
			  name:"",
			  email:"",
			  title:"",
			  text:""
		  }
	  }
  },
    methods:{
	   send :function(){
		   // var iMax = (name > iNum2) ? iNum1 : iNum2;
		   // let issend

		  $.post("test.php", { talk},
		     function(data){
				 console.log(this)
		       console.log(data); //  2pm
		     }, "json");
	  },
	  download(){
		const a = document.createElement("a");
		a.href = "https://hp.godoos.com/app/hplus.apk";
		a.download = "hplus.apk";
		a.click();
		a = null;
	  }
  },
  mounted(){

	  	// Slideshow 4
	  	$("#slider4").responsiveSlides({
	  		auto: true,
	  		pager: true,
	  		nav: true,
	  		speed: 500,
	  		namespace: "callbacks",
	  		before: function() {
	  			$('.events').append("<li>before event fired.</li>");
	  		},
	  		after: function() {
	  			$('.events').append("<li>after event fired.</li>");
	  		}
	  	});

	  	// Slideshow 5
	  	$("#slider5").responsiveSlides({
	  		auto: true,
	  		pager: true,
	  		nav: false,
	  		speed: 500,
	  		namespace: "callbacks",
	  		before: function() {
	  			$('.events').append("<li>before event fired.</li>");
	  		},
	  		after: function() {
	  			$('.events').append("<li>after event fired.</li>");
	  		}
	  	});
		// $("form").submit(function(e){
		//   console.log(this.talka)

		//   $.post("test.php", {  "name":this.talk.name,
		// 						  "email":this.talk.email,
		// 						  "title":this.talk.title,
		// 						  "text":this.talk.text},
		//      function(data){
		//        console.log(data); //  2pm
		//      }, "json");
		// });

  }
}
</script>

<style scoped>
	iframe{
		height: 0;
		content: "";
		overflow: hidden;
	}
</style>
